export const capitalizeFirstLetter = (input: string | undefined): string | null => {
  if (!input) return null;

  return input
    .split(" ")
    .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
